import { render, staticRenderFns } from "./Report5.vue?vue&type=template&id=be87f8ce&scoped=true&"
import script from "./Report5.vue?vue&type=script&lang=js&"
export * from "./Report5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be87f8ce",
  null
  
)

export default component.exports